import React from "react";
import styled from "styled-components";
import { firebaseConnect } from "react-redux-firebase";
import { compose } from "redux";
import { connect } from "react-redux";

import loadingIndicator from "./images/loading.svg";

const Container = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Heading = styled.p`
  margin: 0;
  font-size: 2em;
  .small & {
    font-size: 1em;
  }
`;

const Img = styled.img`
  .small & {
    height: 100px;
  }
`;

export const Loading = ({ auth, small, children }) => {
  return (
    <Container className={small ? "small" : null}>
      {children ? <Heading>{children}</Heading> : <Heading>Laddar ...</Heading>}
      <Img src={loadingIndicator} alt="Laddningsindikator" />
    </Container>
  );
};

export default compose(
  firebaseConnect(), // withFirebase can also be used
  connect(({ firebase: { auth } }) => ({ auth }))
)(Loading);



// WEBPACK FOOTER //
// ./src/Loading.js